export type Speciality =
  | 'all-specialities'
  | 'cardiology'
  | 'nephrology'
  | 'professional-development'
  | 'infectious-diseases'
  | 'imaging'
  | 'emergency-medicine-and-critical-care'
  | 'pulmonary'
  | 'endocrinology'
  | 'hematology'
  | 'ultrasound'
  | 'clinical-reasoning-and-examination'
  | 'neurology-and-psychiatry'
  | 'gastroenterology'
  | 'clinical-pathology'
  | 'dermatology-and-wound-care'
  | 'pharmacology'
  | 'primary-care'
  | 'pediatrics';
  // | 'rheumatology'
  // | 'oncology'

export const SpecialityLabels: Record<Speciality, string> = {
  'all-specialities': 'All Specialities',
  'cardiology': 'Cardiology',
  'nephrology': 'Nephrology',
  'professional-development': 'Professional Development',
  'infectious-diseases': 'Infectious Diseases',
  'imaging': 'Imaging',
  'emergency-medicine-and-critical-care': 'Emergency Medicine and Critical Care',
  'pulmonary': 'Pulmonary',
  'endocrinology': 'Endocrinology',
  'hematology': 'Hematology',
  'ultrasound': 'Ultrasound',
  'clinical-reasoning-and-examination': 'Clinical Reasoning and Examination',
  'neurology-and-psychiatry': 'Neurology and Psychiatry',
  'gastroenterology': 'Gastroenterology',
  'clinical-pathology': 'Clinical Pathology',
  'dermatology-and-wound-care': 'Dermatology and Wound Care',
  'pharmacology': 'Pharmacology',
  'primary-care': 'Primary Care',
  // 'rheumatology': 'Rheumatology',
  // 'oncology': 'Oncology',
  'pediatrics': 'Pediatrics',
};
